<template>
    <sui-list>
        <a is="sui-list-item">
            <sui-popup 
                flowing 
                position="left center"
            >
                <sui-list-content slot="trigger">
                    <sui-label class="gateway-process-state-label" :color="statusColor">{{label}}</sui-label>
                </sui-list-content>

                <GatewayProcessStateInfos v-if="process" :process="process" />
                <template v-else>
                    {{ $t('common.noData') }}
                </template>
            </sui-popup>
        </a>
    </sui-list>
</template>

<script>
import GatewayProcessStateInfos from './GatewayProcessStateInfos.vue';
import { processStatesColors, processStatesLabels } from '@/services/process-states';

export default {
    name: 'GatewayProcessState',
    components: {
        GatewayProcessStateInfos,
    },

    props: {
        process: {
            type: Object,
        }
    },

    data: () => ({
        isModalOpen: false,
    }),

    computed: {
        status() {
            return this.process ? this.process.currentState : 'NONE';
        },

        label() {
            return processStatesLabels[this.status] || this.$t('common.notDetermined');
        },

        statusColor() {
            return processStatesColors[this.status];
        },
    },
};
</script>

<style>
.process-label {
    cursor: pointer;
}

.process-data-row {
    margin-bottom: 5px;
}

.process-data-row .label {
    display: inline-block;
    width: 140px;
    font-weight: bold;
}

.gateway-process-state-label {
    margin-top: 5px !important;
    width: 100%;
}
</style>